export const Tooltip = () => null;

Tooltip['displayName'] = 'TreeMap.Tooltip';
